import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { MedicalFeeAmount } from '../../model/medical-fee/medical-fee-amount';

@Injectable({
  providedIn: 'root'
})
export class MedicalFeeAmountService {

  constructor( private dataService: DataService ) { }

  private readonly recalculateMedicaFeeAmountsEndPoint: string =
          '/medicalFeeAmount/recalculateMedicaFeeAmounts/';

  async recalculateMedicaFeeAmounts( medicalFeeAmount: MedicalFeeAmount ): Promise<MedicalFeeAmount> {

    return await this.dataService
    .post<MedicalFeeAmount>(this.recalculateMedicaFeeAmountsEndPoint, medicalFeeAmount)
    .toPromise();
  }
}
